import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Layout from './layout/Layout';
import ShipmentList from './pages/ShipmentList';
import Handover from './pages/Handover';
import CartonList from './pages/CartonList';
import CustomerManage from './pages/CustomerManage';
import CustomerAddresses from './pages/CustomerAddresses';
import CustomerShipments from './pages/CustomerShipments';
import RouteManage from './pages/RouteManage';
import ChannelManage from './pages/ChannelManage';
import AgentManage from './pages/AgentManage';
import AgentDepotList from './pages/AgentDepotList';
import AgentServiceList from './pages/AgentServiceList';
import SupplierManage from './pages/SupplierManage';
import ProductManage from './pages/ProductManage';

const App: React.FC = () => (
  <BrowserRouter>
    <AuthGuard>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/shipments/list" replace />} />
        {/* 运单管理 */}
        <Route path="shipments/list" element={<ShipmentList />} />
        <Route path="shipments/pre-declaration" element={<Navigate to="/shipments/list" replace />} />
        <Route path="shipments/handover" element={<Handover />} />
        {/* 货物管理 */}
        <Route path="warehouse/cartons" element={<CartonList />} />
        {/* 客户管理 */}
        <Route path="customers/list" element={<CustomerManage />} />
        <Route path="customers/addresses" element={<CustomerAddresses />} />
        <Route path="customers/shipments" element={<CustomerShipments />} />
        {/* 线路管理 */}
        <Route path="routes/list" element={<RouteManage />} />
        <Route path="routes/channels" element={<ChannelManage />} />
        {/* 代理管理 */}
        <Route path="agents/list" element={<AgentManage />} />
        <Route path="agents/depots" element={<AgentDepotList />} />
        <Route path="agents/services" element={<AgentServiceList />} />
        {/* 供应商管理 */}
        <Route path="suppliers/list" element={<SupplierManage />} />
        {/* 产品管理 */}
        <Route path="products/list" element={<ProductManage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </AuthGuard>
  </BrowserRouter>
);

export default App;
